import { FastlyImage } from '@components/common/image'

const PlatformFeatures = () => (
  <div className="bg-yellow-100 bg-opacity-50 pt-12 lg:pt-16 px-5">
    <div className="container mx-auto flex flex-col items-center">
      <h2 className="max-w-4xl mx-auto pb-3 text-2xl text-center text-grey lg:text-4xl font-600">
        Teach live. Track progress. Get support.
      </h2>
      <p className="font-400 text-lg md:text-xl text-center max-w-4xl">
        A stable system backs every class. From lesson flow to progress
        visibility, everything is designed to reduce friction for teachers and
        keep learning on track.
      </p>

      {/* Desktop: image with floating labels */}
      <div className="hidden lg:block relative mt-12">
        <FastlyImage
          src="/images/teacher-lp/platform-features/classroom-desktop.png"
          alt="Codingal classroom platform"
          width={1280}
          height={712}
          className="rounded-xl mx-auto"
        />
      </div>

      {/* Mobile: image + labels as list */}
      <div className="lg:hidden mt-8 w-full flex flex-col gap-6">
        <FastlyImage
          src="/images/teacher-lp/platform-features/classroom-mobile.png"
          alt="Codingal classroom platform"
          width={549}
          height={733}
          className="rounded-xl mx-auto"
        />
      </div>
    </div>
  </div>
)

export default PlatformFeatures
